import React from 'react';
import BusinessDashboardPage from '@/pages/BusinessDashboardPage';

export default function HotelDashboardPage() {
  return <BusinessDashboardPage role="hotel" />;
}
